import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from "../ui/button/button.component";

export interface ConfirmationModalData {
  title: string;
  description: string;
  /** Optional HTML version of `description`. When provided it is rendered via [innerHTML]
   *  so callers can emphasise parts of the message (e.g. <strong>…</strong>).
   *  IMPORTANT: callers MUST escape any user/data-supplied text before wrapping it. */
  descriptionHtml?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'primary';
  loading?: boolean;
  showInput?: boolean;
  inputRequired?: boolean;
  inputPlaceholder?: string;
  alignButtons?: 'start' | 'center' | 'end';
  showDropdown?: boolean;
  dropdownLabel?: string;
  dropdownOptions?: { label: string; value: any }[];
  /** When true, the confirm action stays disabled (e.g. insufficient balance). */
  confirmDisabled?: boolean;
}

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonComponent, FormsModule]
})
export class ConfirmationModalComponent implements OnInit {
  dialogData: ConfirmationModalData | null = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<ConfirmationModalComponent>);

  note = signal('');
  selectedDropdownValue = signal<any>(null);

  ngOnInit() {
    if (this.dialogData?.showDropdown && this.dialogData.dropdownOptions?.length) {
      this.selectedDropdownValue.set(this.dialogData.dropdownOptions[0].value);
    }
  }

  onConfirm(): void {
    const result: any = { confirmed: true };
    if (this.dialogData?.showInput) result.note = this.note();
    if (this.dialogData?.showDropdown) result.dropdownValue = this.selectedDropdownValue();
    
    if (this.dialogData?.showInput || this.dialogData?.showDropdown) {
      this.dialogRef.close(result);
    } else {
      this.dialogRef.close(true);
    }
  }
}
